import React, { useState, useEffect }          from 'react';
import ResiFormLayout               from '../../../components/ResiFormLayout';
import CustomTextFieldAggiungi      from '../../../components/fields/CustomTextFieldAggiungi';
import CustomNoteAggiungi           from '../../../components/fields/CustomNoteAggiungi';
import CustomDragAndDrop            from '../../../components/fields/CustomDragAndDrop';
import DOAIcon                      from '../../../images/DOAicon.png';
import { useNavigate }              from 'react-router-dom';
import CustomDatePickerAggiungi     from '../../../components/fields/CustomDatePickerAggiungi';
import CustomNumberAggiunta         from '../../../components/fields/CustomNumberAggiunta';
import axios                        from 'axios';
import { useTranslation }           from 'react-i18next';
import SendEmail                    from '../../../components/SendEmail';
import SendAvviso                   from '../../../components/SendAvviso';
import dayjs                        from 'dayjs';
import CircularProgressWithLabel    from '../../../components/CircularProgressWithLabel';
import CustomAutocomplete           from '../../../components/fields/CustomAutocomplete';


import {   
    Grid, 
    Button, 
    Box,    
    Typography,    
    Switch,    
    Alert
} from '@mui/material';
import ApiService from '../../../components/service/ApiService';

const DOAForm = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();


    const [alert,                       setAlert                    ] = useState({ open: false, message: '', severity: 'success' });
    const [step,                        setStep                     ] = useState(1);
    const [errors,                      setErrors                   ] = useState({});
    const [message,                     setMessage                  ] = useState('');
    const [snackbarSeverity,            setSnackbarSeverity         ] = useState('success');
    const [loading,                     setLoading                  ] = useState(false);
    const [progress,                    setProgress                 ] = useState(0);
    const [fattureOptions,              setFattureOptions           ] = useState([]);
    const [skuOptions,                  setSkuOptions               ] = useState([]);
    const [skuDetails,                  setSkuDetails               ] = useState([]);
    const [isFatturaSelected,           setIsFatturaSelected        ] = useState(false);
    const [isFetchingFatturaDetails,    setIsFetchingFatturaDetails ] = useState(false);
    const [maxQty,                      setMaxQty                   ] = useState(1);  

    



    const [switchStates,        setSwitchStates     ] = useState({
        scatolaOriginale:   false,
        dannoScatola:       false,
        resocontoTecnico:   false,
        fatturaAcquisto:    false,
    });
    const [uploadedFiles, setUploadedFiles] = useState({
        scatolaOriginale:   [],
        dannoScatola:       [],
        resocontoTecnico:   [],
        fatturaAcquisto:    []
    });
    const [formValues, setFormValues] = useState({
        tipologia: 'DOA',
        numeroFattura: '',
        dataFattura: '',
        quantita: '1',
        skuEan: '',
        imeiSerial: '',
        descrizioneProblema: '',
        dannoFisico: '',
        numeroFatturaReal: '',
        dataCreazioneRMA: dayjs().format('DD/MM/YYYY'),
        richiestaIndirizzo:         false,
        descrizione:                null,
        stato:                      null,
        compagniaTrasporto:         null,
        id:                         null,
        idReso:                     null,
        infoAggiuntive:             null,
        numeroFatturaClienteFinale: null,
        merceFirmataRiserva:        null,
        dataRicezioneMerce:         null,
        dataFatturaClienteFinale:   null,
        possessoResocontoTecnico:   null,
        prodotti: null
    });


    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const headers = {
        Authorization: `Bearer ${token}`
    };

    const idCliente = user?.idCliente;
    const ragioneSociale = user?.ragioneSociale;
    const id = user?.IDCustomerRMT;
    const IDCustomerRMT = user?.idRiba;


    const fetchFatture = async () => {
        setLoading(true);
        try {
            const response = await ApiService.request("getFatture", { id: id });
    
            if (response.data?.code === 200 && Array.isArray(response.data.result)) {
                const today = dayjs();
                const fattureOptions = response.data.result
                    .filter((fattura) => {
                        const fatturaDate = dayjs(fattura.DateInvoice, "YYYYMMDD");
                        return today.diff(fatturaDate, "day") <= 15;
                    })
                    .map((fattura) => ({
                        label: `${fattura.InvoiceNr} - ${dayjs(fattura.DateInvoice, "YYYYMMDD").format("DD/MM/YYYY")}`,
                        value: fattura.InternalIDInvoice,
                        numeroFattura: fattura.InvoiceNr,
                        dataFattura: dayjs(fattura.DateInvoice, "YYYYMMDD").format("DD/MM/YYYY"),
                    }))
                    .reverse();
    
                setFattureOptions(fattureOptions);
            } else {
                console.error("La risposta non contiene un array valido in `result`:", response.data);
            }
        } catch (error) {
            console.error("Errore durante il fetch delle fatture!", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFatture();
    }, []);
    
    

    useEffect(() => {
        let timer;
    
        if (loading) {
            setProgress(0); 
                timer = setInterval(() => {
                setProgress((prevProgress) => {
                    if (prevProgress >= 100) {
                    clearInterval(timer); 
                    setLoading(false); 
                    return 100;
                    }
                return prevProgress + 10; 
                });
            }, 300); 
        }
    
        return () => clearInterval(timer);
    }, [loading]);

    const campiObbligatori = ["numeroFattura", "skuEan", "imeiSerial", "quantita", "descrizioneProblema"];

    const fields = [
        { label: t('Numero della fattura'),                    name: 'numeroFattura',                  type: 'select',  options: fattureOptions,   disabled: false                },
        // { label: t('Data della fattura'),                      name: 'dataFattura',                    type: 'date',    maxLength: 10,             disabled: true                 },
        { label: t('SKU/EAN del prodotto'),                    name: 'skuEan',                         type: 'select',  options: skuOptions,       disabled: !isFatturaSelected   },
        { label: t('IMEI o SERIAL NUMBER'),                    name: 'imeiSerial',                     type: 'text',    maxLength: 20,             disabled: !isFatturaSelected   },
        { label: t('Quantità'),                                name: 'quantita',                       type: 'number',                             disabled: !isFatturaSelected   },
        { label: t('Descrizione del problema riscontrato'),    name: 'descrizioneProblema',            type: 'note',    multiline: true, rows: 4,  disabled: true                 }
    ];

    const handleInputChange = (input) => {
        setFormValues({
            ...formValues,
            ...input,
        });
        setErrors({
            ...errors,
            ...Object.keys(input).reduce((acc, key) => {
                if (input[key] === '') {
                    acc[key] = t('Questo campo è obbligatorio');
                } else {
                    delete errors[key];
                }
                return acc;
            }, {}),
        });
    };

    const handleFilesAdded = (key, files) => {
        setUploadedFiles((prevFiles) => ({
            ...prevFiles,
            [key]: files,
        }));
    };

    const handleResetFileNames = (switchKey) => {
        setUploadedFiles((prevFiles) => ({
            ...prevFiles,
            [switchKey]: [],
        }));
    };

    const handleSwitchChange = (name) => (event) => {
        const isChecked = event.target.checked;
    
        setSwitchStates((prevStates) => ({
            ...prevStates,
            [name]: isChecked,
        }));
    
        if (name === 'dannoScatola' && isChecked) {
            setAlert({
                open: true,
                message: t(
                    "È importante che questo corrisponda con il reale stato del prodotto. In caso contrario non potremo gestire la vostra richiesta come DOA."
                ),
                severity: 'warning',
            });
                setTimeout(() => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    open: false,
                }));
            }, 5000);
        }
    };
    
    
    //funzione per la validazione dei campi
    const validateFields = (values, mandatoryFields) => {
        let errors = {};
        mandatoryFields.forEach((field) => {
            if (!values[field]) {
                errors[field] = t("Questo campo è obbligatorio");
            }
            // if (field === "quantita" && values[field] > maxQty) {
            //     errors[field] = t('La quantità non può superare il massimo di {{maxQty}}.', { maxQty });;
            // }
            if (field === "quantita") {
                const quantita = Number(values[field]);

                if (!quantita || isNaN(quantita)) {
                    errors[field] = t("Questo campo è obbligatorio");
                } else if (quantita < 1) {
                    errors[field] = t("La quantità minima consentita è 1.");
                } else if (quantita > maxQty) {
                    errors[field] = t('La quantità non può superare il massimo di {{maxQty}}.', { maxQty });
                }
            }
        });
        return errors;
    };


    const handleNextClick = () => {
        const validationErrors = validateFields(formValues, campiObbligatori);
        if (Object.keys(validationErrors).length === 0) {
            setStep(2);
        } else {
            setErrors(validationErrors);
        }
    };


    const handleFatturaChange = async (fieldValue) => {
        setLoading(true);
        setIsFetchingFatturaDetails(true);

        const numeroFattura = fieldValue.numeroFattura;

        const selectedFattura = fattureOptions.find(
            (fattura) => fattura.value === numeroFattura
        );
        
        setFormValues((prevValues) => ({
            ...prevValues,
            numeroFattura: fieldValue.numeroFattura,
            numeroFatturaReal: selectedFattura ? selectedFattura.label.split(" - ")[0] : null,
        }));

        setIsFatturaSelected(!!numeroFattura);

        try {
            // const response = await axios.get(
            //     `http://localhost:8080/cliente/riba/dati/fattura/${numeroFattura}`,
            //     { headers: headers }
            // );
            const response = await ApiService.request("getDatiFattura", {numeroFattura: numeroFattura});
    
            if (response.data?.code === 200 && Array.isArray(response.data.result)) {
                const fatturaDettagli = response.data.result; 
                setSkuDetails(fatturaDettagli);
                const skuOptions = fatturaDettagli.map((item) => ({
                    label: item.SKU, 
                    value: item.SKU,
                }));

                setSkuOptions(skuOptions);
                const firstItem = fatturaDettagli[0];
                const deliveryDateFormatted = dayjs(firstItem.DeliveryDate, "YYYYMMDD").format("DD/MM/YYYY");
                setFormValues((prevValues) => ({
                    ...prevValues,
                    dataFattura: deliveryDateFormatted,
                }));
            } else {
                console.error("La risposta non contiene un array valido in `result`:", response.data);
            }
        } catch (error) {
            console.error("Errore durante il fetch dei dettagli della fattura!", error);
        } finally {
            setLoading(false);
            setIsFetchingFatturaDetails(false);
        }
    };

        const handleSkuChange = (fieldValue) => {
            const matchingSkuDetails = skuDetails.filter((item) => item?.SKU === fieldValue?.skuEan);
        
            if (matchingSkuDetails?.length > 0) {
            setMaxQty(matchingSkuDetails?.Qty || 1); 
        
            setFormValues((prevValues) => ({
                ...prevValues,
                skuEan: fieldValue?.skuEan,
                descrizioneProblema: matchingSkuDetails[0]?.Description, 
                quantita: 1,
            }));
            } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                skuEan: fieldValue?.skuEan,
                descrizioneProblema: "",
                quantita: 0,
            }));
            setMaxQty(0);
            }
        };

    const handleSubmit = async () => {
        let dragAndDropErrors = {};
        if (switchStates.scatolaOriginale && uploadedFiles.length === 0) {
            dragAndDropErrors.dragAndDrop = t('Questo campo è obbligatorio');
        }
        const prodotti = [
            {
                descrizione: formValues.descrizione || "",
                skuEan: formValues.skuEan || "",
                imeiSerial: formValues.imeiSerial || "",
                quantita: formValues.quantita || null,
            },
        ];

        const { descrizione, skuEan, imeiSerial, quantita, ...newFormValues } = formValues;

        const datiDaInviare = {
            ...newFormValues,
            prodotti,
        };
        if (Object.keys(dragAndDropErrors).length === 0) {
            try {
                // const response = await axios.post(`http://localhost:8080/rma/salva/${idCliente}`, datiDaInviare, { headers: headers });
                const response = await ApiService.request("rmaClienteSave", {IDCustomerRMT: IDCustomerRMT}, datiDaInviare);

                if (response.status === 200) {

                const id = response.data;

                try {
                    const allFiles = [
                        ...uploadedFiles.scatolaOriginale,
                        ...uploadedFiles.dannoScatola,
                        ...uploadedFiles.resocontoTecnico,
                        ...uploadedFiles.fatturaAcquisto,
                    ];
                    if (allFiles.length > 0) {
                        const formDataIMG = new FormData();
                        allFiles.forEach(file => formDataIMG.append("file", file));
                        const fileNamesString = allFiles.map(file => file.name).join(',');
                        formDataIMG.append("fileNames", fileNamesString);

                        // const responseFile = await axios.post(`http://localhost:8080/rma/salva/file/${id}`, formDataIMG, {
                        //     headers: {
                        //         "Content-Type": "multipart/form-data",
                        //         Authorization: `Bearer ${token}`,
                        //     }
                        // });
                        const responseFile = await ApiService.request("fileSave", { id: id}, formDataIMG, { "Content-Type": "multipart/form-data" })
                    } else {
                        // const responseNullFile = await axios.post(`http://localhost:8080/rma/salva/file/${id}`, null, {
                        //     headers: {
                        //         "Content-Type": "application/json",
                        //         Authorization: `Bearer ${token}`,
                        //     }
                        // });
                        const responseNullFile = await ApiService.request("fileSave", { id: id}, null, { "Content-Type": "multipart/form-data" })

                    }
                    setAlert({ open: true, message: t('Reso inviato con successo!'), severity: 'success' });
                    setTimeout(() => setAlert({ ...alert, open: false }), 6000);
                setFormValues({});
                // const responseRMACreata = await axios.get(`http://localhost:8080/rma/${id}`, { headers: headers});
                const responseRMACreata = await ApiService.request("getRmaID", { idRma: id});
                const idReso = responseRMACreata.data?.idReso;
                
                if(idReso) {
                handleSendEmailAvviso(idReso);
                }
                setTimeout(() => {
                    window.history.back();
                }, 1000); 
            } catch (error) {
                setAlert({ open: true, message: t('Errore durante l\'invio del reso.'), severity: 'error' });
                setTimeout(() => setAlert({ ...alert, open: false }), 6000);
            }
        }
            } catch (error) {
                setAlert({ open: true, message: t('Errore durante l\'invio del reso.'), severity: 'error' });
                setTimeout(() => setAlert({ ...alert, open: false }), 6000);
            }
        } else {
            setErrors(dragAndDropErrors);
        }
    };


    const handleSendEmailAvviso = (idReso) => {
        const idResoDaInviare = idReso
        const destinatario = 'andrearizza6@gmail.com'
        const idDestinatario = 1 
        const messaggio = t('Creazione nuovo RMA tipo DOA') + ` #${idResoDaInviare} ` + t('da parte di') + ` ${ragioneSociale}`;
        const messaggioCreazioneRMA = null;

        /* invio email */
        // SendEmail(
        //     idResoDaInviare,
        //     destinatario,
        //     messaggio,
        //     'NUOVA_RMA',
        //     () => {
        //         setMessage(t('Email di contatto inviata con successo!'));
        //         setSnackbarSeverity('success');
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //     }
        // );

        // SendEmail(
        //     idResoDaInviare,
        //     destinatario,
        //     messaggioCreazioneRMA,
        //     'CREAZIONE_RMA',
        //     () => {
        //         setMessage(t('Email di contatto inviata con successo!'));
        //         setSnackbarSeverity('success');
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity('error');
        //     }
        // );

        // Invio avviso
        SendAvviso(
            idResoDaInviare,
            idDestinatario,
            'NUOVA_RMA',

            () => {
                setMessage(t('Avviso inviato al cliente con successo!'));
                setSnackbarSeverity('success');
            },
            () => {
                setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                setSnackbarSeverity('error');
            }
        )
    };



    const handleBackClick = () => {
        if (step === 2) {
            setStep(1);
        } else {
            navigate(-1);
        }
    };

    const renderFields = (field) => {
        const { name, label, type, ...otherProps } = field;

        switch (type) {
            case 'text':
                return (
                    <CustomTextFieldAggiungi
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        error={!!errors[name]}
                        helperText={errors[name]}
                        {...otherProps}
                    />
                );

            case 'number':
                return (
                    <CustomNumberAggiunta
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={(input) => {
                            handleInputChange(input); 
                        }}
                        onBlur={() => {
                            const value = Number(formValues[name]);

                            if (value < 1) {
                                setFormValues((prevValues) => ({
                                    ...prevValues,
                                    [name]: 1,
                                }));
                                setAlert({
                                    open: true,
                                    message: t('La quantità minima consentita è 1. È stata impostata a 1.'),
                                    severity: 'error'
                                });
                            } else if (value > maxQty) {
                                setFormValues((prevValues) => ({
                                    ...prevValues,
                                    [name]: 1,
                                }));
                                setAlert({
                                    open: true,
                                    message: t('La quantità non può superare il massimo di {{maxQty}}. È stata impostata a 1.', { maxQty }),
                                    severity: 'error'
                                });
                            }
                        }}

                        // onBlur={() => {
                        //     if (formValues[name] > maxQty) {
                        //         setFormValues((prevValues) => ({
                        //             ...prevValues,
                        //             [name]: 1, 
                        //         }));
                        //         setMessage(t('La quantità non può superare il massimo di {{maxQty}}. È stata impostata a 1.', { maxQty }));
                        //         setAlert({ open: true, message: t('Non è possibile inserire una quantità maggiore di {{maxQty}} per questo prodotto.', { maxQty }), severity: 'error' });
                                
                        //         setSnackbarSeverity('error');
                        //     }
                        // }}
                        error={!!errors[name]}
                        helperText={t('Massimo disponibile: {{maxQty}}', { maxQty })}
                        {...otherProps}
                    />
                );

            case 'date':
                return (
                    <CustomDatePickerAggiungi
                        key={name}
                        name={name}
                        label={label}
                        type="date"
                        values={formValues}
                        onChange={handleInputChange}
                        error={!!errors[name]}
                        helperText={errors[name]}
                        {...otherProps}
                    />
                );

                case "select":
                    return (
                    <CustomAutocomplete
                        name={name}
                        label={label}
                        options={field.options}
                        value={formValues[field.name] || null}
                        onChange={(fieldValue) => {
                            if (name === "numeroFattura") handleFatturaChange(fieldValue);
                            if (name === "skuEan") handleSkuChange(fieldValue);
                            setFormValues((prev) => ({ ...prev, ...fieldValue }));
                        }}
                        getOptionSelected={(option, value) => option.value === value.value}
                        {...otherProps}
                    />
                    );

            case 'note':
                return (
                    <CustomNoteAggiungi
                        key={name}
                        name={name}
                        label={label}
                        values={formValues}
                        onChange={handleInputChange}
                        error={!!errors[name]}
                        helperText={errors[name]}
                        {...otherProps}
                    />
                );
            default:
                return null;
        }
    };


    // Funzione per verificare che tutti i campi attivati dagli switch abbiano file caricati
    const validateFileUploads = () => {
        if (!switchStates.dannoScatola) {
            return false;
        }
    
        for (const key in switchStates) {
            if (switchStates[key] && (!uploadedFiles[key] || uploadedFiles[key].length === 0)) {
                return false; 
            }
        }
    
        return true; 
    };
    

    return (
        <ResiFormLayout
            color1="#975F24"
            color2="#FDA03D"
            icon={<Box component="img" src={DOAIcon} alt="Merce Danneggiata" sx={{ width: 40, height: 60 }} />}
            title={t("DOA")}
            onBackClick={handleBackClick}
        >
            <form>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 4
                }}>
                    {step === 1 && (
                        <>
                            <Typography sx={{ p: 2, textAlign: 'center' }}>
                            {t('Vi ricordiamo che, nel caso in cui non dovessimo ricevere il prodotto nelle stesse condizioni in cui lo abbiamo inviato e completo di tutti gli accessori in dotazione, non potremo procedere con la gestione della vostra richiesta.')}
                            </Typography>
                            <Grid container spacing={2}>
                                {fields.map((field) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={field.type === 'note' ? 12 : 6}
                                        key={field.name}
                                    >
                                        {renderFields(field)}
                                    </Grid>
                                ))}
                            </Grid>
                        </>
                    )}

                    {step === 2 && (
                        <>
                            <Typography sx={{ p: 2, textAlign: 'center' }}>
                                {t('Vi ricordiamo che, nel caso in cui non dovessimo ricevere il prodotto nelle stesse condizioni in cui lo abbiamo inviato e completo di tutti gli accessori in dotazione, non potremo procedere con la gestione della vostra richiesta.')}
                            </Typography>
                            <Grid container spacing={3} sx={{ mt: 3 }}>
                                {[
                                    { label: (
                                        <>
                                        <Typography style={{ whiteSpace: 'pre-line' }}>
                                            {t('Sei in possesso della scatola originale?')}
                                        </Typography>
                                        <Typography style={{ whiteSpace: 'pre-line', color: '#9e9e9e' }}>
                                        {t('(Se il N. di serie non è leggibile non si può procedere con l’accettazione del RMA)')}
                                    </Typography>
                                    </>
                                    ), switchKey: 'scatolaOriginale', id: 'fileInput1' 
                                    },
                                    { label: (
                                        <>
                                        <Typography style={{ whiteSpace: 'pre-line' }}>
                                            {t('La scatola è intatta e sei in possesso della scatola originale con tutti gli accessori?')}
                                        </Typography>
                                        <Typography style={{ whiteSpace: 'pre-line', color: '#9e9e9e' }}>
                                        {t('(Nel caso in cui la scatola originale presenti dei danni la preghiamo di aprire la pratica come Riparazione. Grazie)')}
                                    </Typography>
                                    </>
                                    ), switchKey: 'dannoScatola', id: 'fileInput2' 
                                    },
                                    { label: t('Sei già in possesso del resoconto del servizio tecnico ufficiale?'), switchKey: 'resocontoTecnico', id: 'fileInput3' },
                                    { label: t('Hai la fattura di acquisto con meno di 30 giorni?'), switchKey: 'fatturaAcquisto', id: 'fileInput4' }
                                ].map(({ label, switchKey, id }) => (
                                    <React.Fragment key={switchKey}>
                                        <Grid item xs={12} sm={4}>
                                            <Typography sx={{ textAlign: 'left' }}>{label}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Switch
                                                checked={switchStates[switchKey]}
                                                onChange={handleSwitchChange(switchKey)}
                                                color="success"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <CustomDragAndDrop
                                                id={id}
                                                onFilesAdded={(files) => handleFilesAdded(switchKey, files)}
                                                onResetFiles={() => handleResetFileNames(switchKey)}
                                                enabled={switchStates[switchKey]}
                                                error={switchStates[switchKey] && uploadedFiles[switchKey].length === 0 ? !!errors[switchKey] : false}
                                                helperText={switchStates[switchKey] && uploadedFiles[switchKey].length === 0 ? errors[switchKey] : ''}
                                            />
                                        </Grid>
                                    </React.Fragment>
                                ))}
                            </Grid>
                        </>
                    )}


                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6, width: '100%', gap: 3 }}>
                                {step === 2 && (
                                    <Button
                                        variant="contained"
                                        sx={{
                                            width: '150px',
                                            bgcolor: '#a3b0b7',
                                            boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.3)",
                                            borderRadius: '10px',
                                            color: 'white',
                                            "&:hover": {
                                                background: '#8b969b',
                                                transform: 'scale(1.05)'
                                            }
                                        }}
                                        onClick={handleBackClick}
                                    >
                                        {t('INDIETRO')}
                                    </Button>
                                )}
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: '150px',
                                        background: (step === 1 && Object.keys(validateFields(formValues, campiObbligatori)).length > 0) || (step === 2 && !validateFileUploads())
                                        ? 'gray' 
                                        : 'linear-gradient(135deg, #975F24, #FDA03D)', 
                                        boxShadow: "10px 10px 10px rgba(0, 0, 0, 0.1)",
                                        borderRadius: '10px',
                                        "&:hover": {
                                            background: step === 1 && Object.keys(validateFields(formValues, campiObbligatori)).length > 0 ? 'gray' : 'linear-gradient(135deg, #975F24, #FDA03D)',
                                            transform: step === 1 && Object.keys(validateFields(formValues, campiObbligatori)).length > 0 ? 'none' : 'scale(1.05)',
                                        }
                                    }}
                                    onClick={step === 1 ? handleNextClick : handleSubmit}
                                    disabled={
                                        (step === 1 && Object.keys(validateFields(formValues, campiObbligatori)).length > 0) ||
                                        (step === 2 && !validateFileUploads())
                                    }
                                    >
                                    {step === 1 ? t('AVANTI') : t('INVIA')}
                                </Button>

                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </form>
            {alert.open && (
                <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, open: false })}
                sx={{
                    position: 'fixed',
                    top: 20, 
                    left: '50%',
                    transform: 'translateX(-50%)', 
                    zIndex: 9999, 
                    minWidth: '300px',
                    maxWidth: '600px',
                }}
                >
                    {alert.message}
                </Alert>
            )}
            {(loading || isFetchingFatturaDetails) &&  (
                <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'rgba(217, 217, 217, 0.56)',
                    zIndex: 9999,
                }}
                >
                <CircularProgressWithLabel value={progress} />
                </Box>
            )}
        </ResiFormLayout>
    );
};

export default DOAForm;
